module.exports = function getResource(label, vars = []) {
    let resources = {
        sephoraStore: `Sephora ${vars[0]}`,
        pickupInfo: 'Renseignements sur le ramassage',
        callStore: 'Appeler le magasin',
        happeningAt: 'En cours chez Sephora',
        seeWhatsGoingOn: 'Services gratuits, lancements de marques, ateliers et plus - consulter les événements du jour dans votre magasin.',
        seeWhatsHappening: 'Voir les événements dans ce magasin',
        getDirections: 'Obtenir un itinéraire',
        away: 'absent',
        howToFindUs: 'Comment nous trouver?',
        tempClosed: 'Temporarily Closed',
        tempUnavailable: 'Temporarily Unavailable'
    };

    return resources[label];
};
